// İSG Portal — belge yükleme/bağlama formlarının tür + bitiş tarihi kuralı (SAF, React yok; GL #7 D8).
// web-expert'in RHF formları ve web-supplier'ın kontrollü alan grupları AYNI kuralı buradan okur;
// formun davranışı yalnız seçilen türün `expiryRule`'udur:
//   - `EndDateRequired` → bitiş tarihi görünür ve zorunlu;
//   - `EndDateOptional` → görünür, isteğe bağlı;
//   - `NoExpiry` ya da tür yok/bilinmiyor → gizli; tür değişince boşaltılır, ASLA gönderilmez.

import type { DocumentEntity, DocumentTypeDto } from '../api/documentTypes';
import {
  findDocumentType,
  isInactiveOrUnknownDocumentType,
  requiresValidUntil,
  showsValidUntil,
} from './documentTypeRegistry';

type Types = readonly DocumentTypeDto[] | undefined;

/** İki portalın form değerlerinin ortak alt kümesi (RHF şemasında `validUntil` opsiyoneldir). */
export interface DocumentTypeFormValues {
  type: string;
  validUntil?: string | undefined;
}

/**
 * Kod şu an seçilebilir mi: kayıt yüklü, kod boş değil, bu entity'de kayıtlı ve aktif. Pasifleşmiş
 * eski bir seçim seçilemez sayılır (seçici onu göstermez, form onunla tamamlanmaz).
 */
export function isSelectableDocumentType(
  types: Types,
  entity: DocumentEntity,
  code: string,
): boolean {
  return (
    types !== undefined && code !== '' && !isInactiveOrUnknownDocumentType(types, entity, code)
  );
}

/** Gönderilecek `validUntil`: alan türün kuralıyla gizliyse (ya da boşsa) daima `null`. */
export function validUntilToSend(
  types: Types,
  entity: DocumentEntity,
  values: DocumentTypeFormValues,
): string | null {
  const value = values.validUntil?.trim() ?? '';
  return showsValidUntil(findDocumentType(types, entity, values.type)) && value.length > 0
    ? value
    : null;
}

/** Türün kuralı bitiş tarihini zorunlu kılıyor ama tarih boş mu. */
export function missingRequiredValidUntil(
  types: Types,
  entity: DocumentEntity,
  values: DocumentTypeFormValues,
): boolean {
  return (
    requiresValidUntil(findDocumentType(types, entity, values.type)) &&
    (values.validUntil?.trim() ?? '').length === 0
  );
}

/**
 * Tür değişiminin değere etkisi: yeni tür tarihi gizliyorsa bitiş tarihi boşaltılır — görünmeyen bir
 * tarih sessizce taşınmaz (D8).
 */
export function withDocumentType<T extends DocumentTypeFormValues>(
  types: Types,
  entity: DocumentEntity,
  values: T,
  code: string,
): T {
  return showsValidUntil(findDocumentType(types, entity, code))
    ? { ...values, type: code }
    : { ...values, type: code, validUntil: '' };
}
